import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home/Home';
import LoginForm from './components/auth/LoginForm';
import SignupForm from './components/auth/SignupForm'; 
import Layout from './components/common/Layout';
import BoardPage from './pages/Lost/BoardPage';
import ItemCreatePage from './pages/Lost/ItemCreatePage';
import ClubList from './pages/Club/ClubList';
import ClubDetailPage from './pages/Club/ClubDetailPage'
import Schedule from './pages/Schedule/Schedule'
import Profile from './pages/Profile/Profile'
import NotificationList from './pages/Notification/NotificationList';
import NotificationDetail from './pages/Notification/NotificationDetail';
import KeyWordManage from './pages/Notification/KeyWordManage';
import ClubApprovalCard from './components/admin/ClubApprovalCard';
import ClubMembersView from './components/club/ClubMembersView';
import ClubSettings from './components/club/ClubSettings';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/clubs" element={<ClubList />} />
          <Route path="/clubs/:id" element={<ClubDetailPage />} />
          <Route path="/lost" element={<BoardPage />} />
          <Route path="/lost/create" element={<ItemCreatePage />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/signup" element={<SignupForm />} />
          <Route path="/notifications" element={<NotificationList/>}/>
          <Route path="/notifications/:id" element={<NotificationDetail/>}/>
          <Route path="/profile/keywordmanage" element={<KeyWordManage />}/>
          <Route path="/notifications" element={<NotificationList />} />
          <Route path="/notifications/:id" element={<NotificationDetail />} />
          <Route path="/notifications/keywordmanage" element={<KeyWordManage />} />
          <Route path="/admin" element={<ClubApprovalCard />} />
          <Route path="/clubs/:id/members" element={<ClubMembersView />} />
          <Route path="clubs/:id/setting" element={<ClubSettings />} />4
          <Route path="/club/:id/schedule" element={<Schedule />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}